import { toaster } from 'baseui/toast';
import { useEffect } from 'react';
import { useHannibalQuery } from '../../../common/schema/hannibal/HannibalContext';
import { CovidRedirectToastDocument } from '../../../common/schema/hannibal/types.generated';

export const CovidRedirectToast = ({ practiceId }: { practiceId: string }) => {
  const queryResult = useHannibalQuery(CovidRedirectToastDocument, { variables: { practiceId } });
  const name = queryResult.data?.practice?.name;

  useEffect(() => {
    if (name !== undefined) {
      toaster.negative(
        <>
          <p>
            Sorry, {name} does not currently have any online appointments available for COVID-19
            vaccinations.
          </p>
          <p>Additional vaccination clinics are listed below.</p>
        </>,

        {},
      );
    }
  }, [name]);

  return null;
};
